<template>
	<svg :id="_id" :width="svgWidth" :height="svgHeight">
		<line :x1="tick.x1" :x2="tick.x2" :y1="tick.y1" :y2="tick.y2" stroke="#777" stroke-width="1" v-for="tick in minorTicks"/>
		<line :x1="tick.x1" :x2="tick.x2" :y1="tick.y1" :y2="tick.y2" stroke="#777" stroke-width="1" v-for="tick in majorTicks"/>
		<text v-if="horizontal" :x="tick.x1+textOffset" y="15" fill="black" font-size="10" v-for="tick in majorTicks">{{tick.value}}</text>
		<text v-if="vertical" :y="tick.y1+12" x="5" fill="black" font-size="10" v-for="tick in majorTicks">{{tick.value}}</text>
	</svg>
</template>
<script>
import PointMeasure from './PointMeasure'

export default {
	props: ['unit', 'scale', 'orientation', 'zoom', 'length'],
	data() {
		return {
			zoom100: 5,
			textOffset: 3,
			minorTicks: [],
			majorTicks: [],
		}
	},
	computed:{
		horizontal() {
			return this.orientation === "horizontal";
		},
		vertical() {
			return this.orientation === "vertical";
		},
		svgWidth() {
			return this.vertical ? "30" : "3000";
		},
		svgHeight() {
			return this.vertical ? "3000" : "30";
		},
		_scale() {
			return parseFloat(this.scale) || 1;
		},
		_dpi() {
			return this.dpi || 96;
		},
		_id() {
 			return this.makeId()
		}
	},
	mounted() {
		this.draw();
	},
	methods: {
		makeId(){
			let text = "";
			const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
			for( let i=0; i < 5; i++ ) text += possible.charAt(Math.floor(Math.random() * possible.length));
			return text;
		},
		scalePixel(n) {
 			return n * this._scale / (Math.pow(2, (this.zoom100 - this.zoom)));
		},
		tickInch() {
			// this._scale is the ratio of point to pixel
			// 72 points per inch
			return this.scalePixel(72); // * this._scale / (Math.pow(2, (this.zoom100 - this.zoom)));
		},
		tickMm(n = 1) {
			return this.scalePixel(n * 2.834645669291339); // * this._scale / (Math.pow(2, (this.zoom100 - this.zoom)));
		},
		draw() {
			this.majorTicks = [];
			this.minorTicks = [];

			// default inches
			let unit = '"';
			let multiple = 1;
			let tickPixels = this.tickInch();
			let divisions = 4;

			if (this.unit === "mm") {
				multiple = 10;
				divisions = 2;
				unit="";
				tickPixels = this.tickMm(multiple);
				if (tickPixels < 20) {
					multiple = 100;
					tickPixels = this.tickMm(100);
					divisions = 10;
				}
			}

			const tickCount = this.scalePixel(this.length) / tickPixels;
			const tickStart = -Math.ceil(tickCount);
			const tickEnd = Math.ceil(tickCount);

			if (this.orientation==="horizontal") {

				for (let i=tickStart; i<tickEnd; i++) {
					const majorTick = {
						x1: (i * tickPixels) + 2,
						x2: (i * tickPixels) + 2,
						y1: 10,
						y2: 30,
						value: `${i * multiple}${unit}`
					};
					this.majorTicks.push(majorTick);
					for (let m=1; m < divisions; m++) {
						const minorTick = {
							x1: majorTick.x1 + (m * (tickPixels / divisions)),
							x2: majorTick.x2 + (m * (tickPixels / divisions)),
							y1: 20,
							y2: 30
						};
						this.minorTicks.push(minorTick);
					}
				}

			}	else {

				for (let i=tickStart; i<tickEnd; i++) {
					const majorTick = {
						y1:  (i * tickPixels) + 2,
						y2: (i * tickPixels) + 2,
						x1: 10,
						x2: 30,
						value: `${i * multiple}${unit}`
					};
					this.majorTicks.push(majorTick);
					for (let m=1; m < divisions; m++) {
						const minorTick = {
							y1: majorTick.y1 + (m * (tickPixels / divisions)),
							y2: majorTick.y2 + (m * (tickPixels / divisions)),
							x1: 20,
							x2: 30
						};
						this.minorTicks.push(minorTick);
					}
				}

			}
		},
	},
	watch: {
		unit() {
			this.draw();
		},
		scale() {
			this.draw();
		},
		dpi() {
			this.draw();
		},
		zoom() {
			this.draw();
		}
	}
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// Ruler.vue?c0289634